import React from 'react';
import Navigation from './Navigation';
import './home.css';

/* ── Inline SVG placeholders (swap for real <img src={...}/> once you have assets) ── */

const HeroIllustration = () => (
  <svg viewBox="0 0 480 340" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 480, borderRadius: 12 }}>
    <rect width="480" height="340" rx="14" fill="#e8f4f0"/>
    {/* dashboard card */}
    <rect x="32" y="32" width="416" height="276" rx="10" fill="#fff" stroke="#d0dce8" strokeWidth="1.5"/>
    {/* header bar */}
    <rect x="32" y="32" width="416" height="48" rx="10" fill="#1a2b4a"/>
    <circle cx="60" cy="56" r="8" fill="#4fc3a1"/>
    <rect x="76" y="50" width="100" height="12" rx="4" fill="#4a6080"/>
    <rect x="340" y="48" width="90" height="16" rx="6" fill="#4fc3a1" opacity="0.9"/>
    {/* control rows */}
    {[0,1,2,3,4].map(i => (
      <g key={i}>
        <rect x="48" y={104 + i * 38} width="280" height="12" rx="4" fill="#e2eaf2"/>
        <rect x="48" y={104 + i * 38} width={100 + i * 30} height="12" rx="4" fill={i < 3 ? '#4fc3a1' : '#f0b429'} opacity="0.85"/>
        <rect x="360" y={100 + i * 38} width="60" height="20" rx="6" fill={i < 3 ? '#e0f2ec' : '#fff8e6'}/>
        <rect x="368" y={105 + i * 38} width={i < 3 ? 44 : 32} height="10" rx="3" fill={i < 3 ? '#1a8a6a' : '#c87f00'} opacity="0.7"/>
      </g>
    ))}
    {/* legend */}
    <circle cx="56" cy="298" r="6" fill="#4fc3a1"/>
    <rect x="68" y="293" width="60" height="10" rx="3" fill="#aab8c8"/>
    <circle cx="160" cy="298" r="6" fill="#f0b429"/>
    <rect x="172" y="293" width="60" height="10" rx="3" fill="#aab8c8"/>
  </svg>
);

const FeaturesIllustration = () => (
  <svg viewBox="0 0 480 340" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 480, borderRadius: 12 }}>
    <rect width="480" height="340" rx="14" fill="#f4f8fb"/>
    {/* Framework tiles */}
    {[
      { x: 40, y: 40, label: 'ISO 27001', color: '#1a2b4a' },
      { x: 180, y: 40, label: 'SOC 2', color: '#4fc3a1' },
      { x: 320, y: 40, label: 'GDPR', color: '#2563eb' },
      { x: 40, y: 150, label: 'HIPAA', color: '#7c3aed' },
  
    ].map(({ x, y, label, color }) => (
      <g key={label}>
        <rect x={x} y={y} width="120" height="80" rx="10" fill="#fff" stroke="#d0dce8" strokeWidth="1.5"/>
        <rect x={x} y={y} width="120" height="6" rx="3" fill={color} opacity="0.85"/>
        <rect x={x+14} y={y+22} width="60" height="10" rx="3" fill={color} opacity="0.7"/>
        <rect x={x+14} y={y+42} width="86" height="8" rx="3" fill="#e2eaf2"/>
        <rect x={x+14} y={y+58} width="64" height="8" rx="3" fill="#e2eaf2"/>
      </g>
    ))}
    {/* Evidence collected indicator */}
    <rect x="40" y="258" width="400" height="50" rx="10" fill="#e0f2ec" stroke="#4fc3a1" strokeWidth="1.5"/>
    <circle cx="68" cy="283" r="14" fill="#4fc3a1"/>
    <path d="M62 283l4 4 8-8" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="90" y="274" width="180" height="10" rx="4" fill="#1a2b4a" opacity="0.6"/>
    <rect x="90" y="292" width="120" height="8" rx="4" fill="#aab8c8"/>
    <rect x="390" y="275" width="34" height="16" rx="6" fill="#4fc3a1"/>
  </svg>
);

const BenefitsIllustration = () => (
  <svg viewBox="0 0 480 340" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 480, borderRadius: 12 }}>
    <rect width="480" height="340" rx="14" fill="#f4f8fb"/>
    {/* Donut chart */}
    <circle cx="160" cy="170" r="90" fill="none" stroke="#e2eaf2" strokeWidth="28"/>
    <circle cx="160" cy="170" r="90" fill="none" stroke="#4fc3a1" strokeWidth="28"
      strokeDasharray="452" strokeDashoffset="90" strokeLinecap="round" transform="rotate(-90 160 170)"/>
    <circle cx="160" cy="170" r="90" fill="none" stroke="#f0b429" strokeWidth="28"
      strokeDasharray="452" strokeDashoffset="362" strokeLinecap="round" transform="rotate(-90 160 170)"/>
    <text x="160" y="165" textAnchor="middle" fontSize="26" fontWeight="800" fill="#1a2b4a">92%</text>
    <text x="160" y="188" textAnchor="middle" fontSize="12" fill="#5a7085">Compliant</text>
    {/* Legend */}
    <circle cx="288" cy="120" r="8" fill="#4fc3a1"/>
    <text x="304" y="125" fontSize="13" fill="#1a2b4a">Passed controls</text>
    <circle cx="288" cy="148" r="8" fill="#f0b429"/>
    <text x="304" y="153" fontSize="13" fill="#1a2b4a">In progress</text>
    <circle cx="288" cy="176" r="8" fill="#e2eaf2"/>
    <text x="304" y="181" fontSize="13" fill="#1a2b4a">Not started</text>
    {/* Summary stats */}
    <rect x="272" y="210" width="172" height="48" rx="8" fill="#fff" stroke="#d0dce8" strokeWidth="1.5"/>
    <text x="288" y="231" fontSize="11" fill="#5a7085">Last audit</text>
    <text x="288" y="250" fontSize="13" fontWeight="700" fill="#1a2b4a">0 exceptions</text>
    <circle cx="412" cy="238" r="14" fill="#e0f2ec"/>
    <path d="M406 238l4 4 8-8" stroke="#1a8a6a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function Home() {
  return (
    <div>
      <Navigation />

      {/* ── Hero ── */}
      <div className="hero-section">
        <div className="text-content">
          <span className="hero-badge">Compliance Automation</span>
          <h1>Audit-Ready, Always.<br />ComplianceGenie automates the rest.</h1>
          <p>
            Stop chasing evidence spreadsheets and last-minute audit scrambles.
            ComplianceGenie continuously monitors your controls, collects evidence automatically,
            and keeps you ready for ISO 27001, SOC 2, GDPR, and HIPAA — all from one place.
          </p>
          <div className="hero-actions">
            {/*<a href="https://compliancegenie.cloudservesystems.com/login/" target="_blank" rel="noreferrer" className="btn-primary">
              Start Free Trial
            </a> */}
            <a href="/contactus" className="btn-secondary">Request a Demo</a>
          </div>
        </div>
        <div className="image-content">
          <HeroIllustration />
        </div>
      </div>

      {/* ── Stats bar ── */}
      <div className="stats-bar">
        <div className="stat-item">
          <span className="stat-number">4+</span>
          <span className="stat-label">Frameworks Supported</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">80%</span>
          <span className="stat-label">Reduction in audit prep time</span>
        </div>
        {/*<div className="stat-item">
          <span className="stat-number">Auto</span>
          <span className="stat-label">Evidence Collection</span>
        </div> */}
        <div className="stat-item">
          <span className="stat-number">Multi-tenant</span>
          <span className="stat-label">Client Management</span>
        </div>
      </div>

      {/* ── Key Features ── */}
      <div className="main-content alt-bg">
        <div className="image-content">
          <FeaturesIllustration />
        </div>
        <div className="text-content">
          <h1>Key Features</h1>
          <ol>
            <li><b>Multi-Framework Control Registry:</b> Manage ISO 27001, SOC 2, GDPR and HIPAA controls in a single unified registry — mapped, versioned, and always up to date.</li><br />
            <li><b>Automated Evidence Collection:</b> Connect your AWS, Azure, or GCP environment and let ComplianceGenie gather evidence automatically using cross-account roles and secure storage.</li><br />
            <li><b>Policy & Task Management:</b> Assign implementation tasks, track evidence descriptions, and attach supporting documentation directly to each control.</li><br />
            <li><b>Multi-Tenant Client Portal:</b> Built for compliance consultants — manage multiple client organizations from a single dashboard with isolated data and role-based access.</li><br />
            <li><b>Audit-Ready Reports:</b> Generate gap assessments, audit summaries, and compliance status reports in seconds, ready to share with auditors or stakeholders.</li><br />
          </ol>
        </div>
      </div>

      {/* ── Frameworks ── */}
      <div className="frameworks-section">
        <h2>Supported Compliance Frameworks</h2>
        <p className="subtitle">One platform for every framework your clients need.</p>
        <div className="frameworks-grid">
          {['ISO 27001', 'SOC 2 Type I & II', 'GDPR', 'HIPAA'].map(fw => (
            <div className="framework-badge" key={fw}>{fw}</div>
          ))}
        </div>
      </div>

      {/* ── End User Benefits ── */}
      <div className="main-content">
        <div className="text-content">
          <h1>Why Compliance Teams Love It</h1>
          <ol>
            <li><b>Always Audit-Ready:</b> Continuous control monitoring means you're never caught off guard. Walk into any audit with confidence.</li><br />
            <li><b>Evidence on Autopilot:</b> Automated AWS, Azure, and cloud integrations collect and store evidence without manual effort — saving weeks per audit cycle.</li><br />
            <li><b>Consultant-First Design:</b> Manage multiple clients from one login. Assign tasks, track progress, and deliver reports without switching tools.</li><br />
            <li><b>Gap Analysis in Minutes:</b> Instantly identify missing controls and unmet requirements across any framework, with clear remediation guidance.</li><br />
            <li><b>Scales with Your Practice:</b> Whether you manage 2 clients or 200, ComplianceGenie grows with you — no per-seat surprises.</li><br />
          </ol>
        </div>
        <div className="image-content">
          <BenefitsIllustration />
        </div>
      </div>

      {/* ── CTA ── */}
      <div className="cta-section">
        <h1>Ready to simplify compliance?</h1>
        <p>
          Join compliance teams across India who use ComplianceGenie to automate evidence collection,
          streamline audits, and deliver results faster. Start your free trial today — no credit card required.
        </p>
        <div className="hero-actions" style={{ justifyContent: 'center' }}>
          <a href="https://portal.compliancegenie.cloudservesystems.com/" target="_blank" rel="noreferrer" className="btn-primary">
            Get Started
          </a>
          <a href="/contactus" className="btn-secondary" style={{ color: '#3d5068', borderColor: '#3d5068' }}>
            Talk to Us
          </a>
        </div>
      </div>

      {/* ── Footer ── */}
      <section className="footer">
        <h4>Cloudserve Systems Pvt. Ltd.</h4>
        <p>G-202, Maple Tree, Near Surdhara Circle, Thaltej, Ahmedabad – 380052, India</p>
        <div className="icons">
          +91 760 000 2540
          <div className="Policy">
            <a href="/privacy.html" target="_blank" rel="noreferrer"><b>Privacy Policy</b></a>
            <a href="/term_conditions.html" target="_blank" rel="noreferrer"><b>Terms of Use</b></a>
          </div>
        </div>
        <p>Copyright © 2017 Cloudserve Systems Pvt. Ltd. All rights reserved.</p>
      </section>
    </div>
  );
}

export default Home;
